import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../firebase';

export default function useHealthProfile({ schoolId, studentId }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!schoolId || !studentId) {
      setProfile(null);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    setError(null);

    const ref = doc(db, 'schools', schoolId, 'students', studentId);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          setProfile(snap.data().healthProfile || {});
        } else {
          setProfile(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('[useHealthProfile] snapshot error:', err);
        setError(err);
        setLoading(false);
      },
    );

    return () => {
      try { unsub?.(); } catch (_) {}
    };
  }, [schoolId, studentId]);

  return { profile, loading, error };
}
